import { useQuery } from "@tanstack/react-query";

import { listCallRecordings } from "../api/ChatApi";

const TWO_MINUTES = 2 * 60 * 1000;

/** Loads call/meeting activities for the record (gallery gating + transcript picker). */
export function useCallRecordings(
  workspaceId: string | undefined | null,
  recordId: string | undefined | null
) {
  return useQuery({
    queryKey: ["crm-chat", "call-recordings", workspaceId, recordId],
    queryFn: () => listCallRecordings(workspaceId as string, recordId as string),
    enabled: Boolean(workspaceId && recordId),
    staleTime: TWO_MINUTES,
    refetchOnWindowFocus: true,
  });
}
